class FixedAtc {
  constructor(root) {
    this.root = root;
    this.sectionId = root.dataset.sectionId;
    this.formId = root.dataset.productFormId;
    this.form = document.getElementById(this.formId);
    this.mainAtc = this.form ? this.form.querySelector('[name="add"]') : null;
    this.triggers = Array.from(root.querySelectorAll('[data-fixed-atc-trigger]'));
    this.init();
  }

  init() {
    if (!this.form || this.triggers.length === 0) return;

    this.cleanupExistingBars();
    this.mountBarsToBody();
    this.bindEvents();
    this.syncState();
    this.observeMainButton();
  }

  cleanupExistingBars() {
    document.querySelectorAll(`.fixed-atc-bar[data-fixed-atc-section="${this.sectionId}"]`).forEach((bar) => {
      bar.remove();
    });
  }

  mountBarsToBody() {
    const bars = Array.from(this.root.querySelectorAll('.fixed-atc-bar'));
    bars.forEach((bar) => {
      if (bar.parentElement !== document.body) {
        document.body.appendChild(bar);
      }
    });
    this.root.remove();
  }

  bindEvents() {
    this.triggers.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.mainAtc) {
          this.mainAtc.click();
          return;
        }
        if (this.form.requestSubmit) {
          this.form.requestSubmit();
        } else {
          this.form.submit();
        }
      });
    });

    this.form.addEventListener('change', () => this.syncState());
    this.form.addEventListener('input', () => this.syncState());
    document.addEventListener('variantChange', () => this.syncState());
  }

  observeMainButton() {
    if (!this.mainAtc || !window.MutationObserver) return;

    const observer = new MutationObserver(() => this.syncState());
    observer.observe(this.mainAtc, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['disabled', 'class', 'aria-disabled']
    });
  }

  syncState() {
    const disabled = this.mainAtc
      ? this.mainAtc.disabled || this.mainAtc.getAttribute('aria-disabled') === 'true'
      : false;

    const label = this.getMainButtonLabel();

    this.triggers.forEach((button) => {
      button.disabled = disabled;
      button.textContent = label;
    });
  }

  getMainButtonLabel() {
    if (!this.mainAtc) return 'Aggiungi al carrello';

    const span = this.mainAtc.querySelector('span');
    const text = span ? span.textContent : this.mainAtc.textContent;
    const cleaned = text ? text.trim().replace(/\s+/g, ' ') : '';

    return cleaned || 'Aggiungi al carrello';
  }
}

function initFixedAtc() {
  document.querySelectorAll('.fixed-atc-root:not([data-fixed-atc-init])').forEach((root) => {
    root.setAttribute('data-fixed-atc-init', 'true');
    new FixedAtc(root);
  });
}

document.addEventListener('DOMContentLoaded', initFixedAtc);
document.addEventListener('shopify:section:load', initFixedAtc);
document.addEventListener('shopify:section:unload', (event) => {
  const sectionId = event.detail && event.detail.sectionId ? event.detail.sectionId : null;
  if (!sectionId) return;
  document.querySelectorAll(`.fixed-atc-bar[data-fixed-atc-section="${sectionId}"]`).forEach((bar) => {
    bar.remove();
  });
});
